import script from "./DashCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashCard.vue?vue&type=script&setup=true&lang=js"

import "./DashCard.vue?vue&type=style&index=0&id=56fbcffa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fbcffa"]])

export default __exports__